import React from 'react'

function Footer() {
    return (
        <footer className="container-fluid no-left-padding no-right-padding footer-main">
            {/* Instagram */}
            {/* <div className="container-fluid no-left-padding no-right-padding instagram-block">
                <ul className="instagram-carousel">
                    <li><a href="#"><img src="http://placehold.it/319x319/aaa" alt="Instagram" /></a></li>
                    <li><a href="#"><img src="http://placehold.it/319x319" alt="Instagram" /></a></li>
                    <li><a href="#"><img src="http://placehold.it/319x319/aaa" alt="Instagram" /></a></li>
                    <li><a href="#"><img src="http://placehold.it/319x319" alt="Instagram" /></a></li>
                    <li><a href="#"><img src="http://placehold.it/319x319/aaa" alt="Instagram" /></a></li>
                    <li><a href="#"><img src="http://placehold.it/319x319" alt="Instagram" /></a></li>
                </ul>
            </div> */}
            {/* Container */}
            <div className="containerFtrSocial">
                {/* <ul className="ftr-social">
                <li><a href="https://www.facebook.com/grupospaggiari" target="_blank" title><i className="ion-social-facebook-outline" /></a></li>
                    <li><a href="https://www.instagram.com/GrupoSpaggiari/" target="_blank" title><i className="ion-social-instagram-outline" /></a></li>
                    <li><a href="https://www.youtube.com/channel/UCHg9fpcoZ5OzmdAD-o9EPmg" target="_blank" title><i className="ion-social-youtube-outline" /></a></li>
                </ul> */}
                <div className="copyright">
                    <p>Copyright @ 2022 Grupo Spaggiari</p>
                </div>
            </div>
        </footer>
    )
}

export default Footer
